import { Record as record } from 'immutable';
import _ from 'lodash';

import trainTime from '../../lib/TrainTime';
import { resolve, resolveAll } from '../../helpers/LinkMapper';

import KeyGoTap from './KeyGoTap';

const defaults = _.zipObject([
    'journeyId',
    'description',
    'transitMode',
    'origin',
    'destination',
    'routeName',
    'fare',
    'startTime',
    'endTime',
    'type',
    'taps'
]);

class KeyGoJourneyPattern extends record(defaults) {

    static fromJSON (json = {}) {
        const data = {
            journeyId: resolve(json.journeyId).with(Number),
            description: resolve(json.description).with(String),
            transitMode: resolve(json.transitMode).with(String),
            origin: resolve(json.origin).with(String),
            destination: resolve(json.destination).with(String),
            routeName: resolve(json.routeName).with(String),
            fare: resolve(json.fare).with(Number),
            startTime: resolve(json.startTime).with(trainTime),
            endTime: resolve(json.endTime).with(trainTime),
            type: resolve(json.type).with(String),
            taps: resolveAll(json.taps).as(KeyGoTap)
        };
        return new KeyGoJourneyPattern(data);
    }

}

export default KeyGoJourneyPattern;



// WEBPACK FOOTER //
// ./src/records/customer/KeyGoJourneyPattern.js